import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      retryDelay: 500,
      refetchIntervalInBackground: true,
      refetchOnReconnect: true,
      refetchInterval: 1 * 60 * 1000,
      refetchOnWindowFocus: true
    },
  },
})
